module.exports = __webpack_public_path__ + "img/tp-4.4cd8aa6e.png";